import React, { type ReactNode, useCallback, useEffect, useState } from 'react';
import { useFeatureFlags } from '@johnlewispartnership/wtr-website-decisioner-client/express';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { EligibilityStatus } from 'services/intelligentShoppingExperience/types';
import intelligentShoppingExperienceServiceClient from 'services/intelligentShoppingExperience';
import ShopByListContext from './ShopByListContext';

interface ShopByListProviderProps {
  children: ReactNode;
}

const ShopByListProvider = ({ children }: ShopByListProviderProps) => {
  const { agenticShopping_enableListToBasket: enableShopByListPage } = useFeatureFlags();
  const { state: authentication } = useAuthentication();

  const authHeader = authentication.token?.authHeader;
  const isLoggedIn = authentication.isLoggedIn && authHeader;

  const [loading, setLoading] = useState<boolean>(false);
  const [eligibilityStatus, setEligibilityStatus] = useState<EligibilityStatus | null>(null);

  const value = eligibilityStatus ?? EligibilityStatus.INELIGIBLE;

  const getEligibility = useCallback(async () => {
    setLoading(true);

    const eligibility = await intelligentShoppingExperienceServiceClient.getEligibility({
      authHeader: authHeader!,
    });

    setLoading(false);
    setEligibilityStatus(eligibility.status);
  }, [authHeader]);

  useEffect(() => {
    if (!enableShopByListPage || !isLoggedIn || !!eligibilityStatus || loading) {
      return;
    }

    getEligibility();
  }, [eligibilityStatus, enableShopByListPage, getEligibility, isLoggedIn, loading]);

  return <ShopByListContext.Provider value={value}>{children}</ShopByListContext.Provider>;
};

export default ShopByListProvider;
